<template>
  <v-row justify="center" v-if="this.message">
    <v-col cols="6">
      <v-card>
        <v-toolbar flat>
          <user-block
            v-for="user in this.message.users"
            :key="user.uuid"
            @show="showUser"
            :user="user"
          />
        </v-toolbar>

        <v-divider></v-divider>
        <v-container>
          <message-box
            owner
            v-for="message in this.message.messages"
            :key="message.uuid"
            :user="getUser(message.sender_uuid)"
            v-bind="message"
          />
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import MessageBox from "../../components/message/MessageBox";
import UserBlock from "../../components/message/UserBlock";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    "message-box": MessageBox,
    "user-block": UserBlock
  },

  computed: {
    ...mapState("message", {
      fetching: "fetching",
      message: "message"
    })
  },
  methods: {
    ...mapActions("message", {
      fetch: "show"
    }),
    showUser(uuid) {
      this.$router.push({
        name: "users.show",
        params: { uuid }
      });
    },
    getUser(uuid) {
      return this.message.users.find(user => user.uuid == uuid);
    }
  },
  mounted() {
    if (this.$route.params.uuid) {
      this.fetch(this.$route.params.uuid);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>